(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["10-slidehow"] && !Shopify.designMode) return;
  try {
    
(function() {
  function inicializarTickerInfinito(contenedor) {
    if (contenedor.dataset.tickerInicializado === 'true') return;
    contenedor.dataset.tickerInicializado = 'true';

    var pista = contenedor.querySelector('.seccion-ticker-infinito__pista');
    var grupo = contenedor.querySelector('.seccion-ticker-infinito__grupo');
    if (!pista || !grupo) return;

    var velocidadSegundos = parseFloat(contenedor.dataset.velocidad) || 25;
    var pausaHover = contenedor.dataset.pausaHover === 'true';
    var posicion = 0;
    var anchoGrupo = 0;
    var enPausa = false;
    var idAnimacion = null;
    var ultimoTiempo = null;

    function calcularAncho() {
      anchoGrupo = grupo.getBoundingClientRect().width;
    }

    function pasoAnimacion(tiempoActual) {
      if (ultimoTiempo === null) ultimoTiempo = tiempoActual;
      var delta = tiempoActual - ultimoTiempo;
      ultimoTiempo = tiempoActual;

      if (!enPausa && anchoGrupo > 0) {
        var pixelesPorMs = anchoGrupo / (velocidadSegundos * 1000);
        posicion -= pixelesPorMs * delta;
        if (Math.abs(posicion) >= anchoGrupo) {
          posicion += anchoGrupo;
        }
        pista.style.transform = 'translateX(' + posicion + 'px)';
      }

      idAnimacion = requestAnimationFrame(pasoAnimacion);
    }

    calcularAncho();
    idAnimacion = requestAnimationFrame(pasoAnimacion);

    if (pausaHover) {
      contenedor.addEventListener('mouseenter', function() {
        enPausa = true;
      });
      contenedor.addEventListener('mouseleave', function() {
        enPausa = false;
      });
    }

    window.addEventListener('resize', calcularAncho);

    var imagenes = contenedor.querySelectorAll('img');
    imagenes.forEach(function(img) {
      if (!img.complete) {
        img.addEventListener('load', calcularAncho);
      }
    });

    document.addEventListener('shopify:section:unload', function(evento) {
      if (evento.target.contains(contenedor) && idAnimacion) {
        cancelAnimationFrame(idAnimacion);
        contenedor.dataset.tickerInicializado = 'false';
      }
    });
  }

  document.querySelectorAll('.seccion-ticker-infinito').forEach(inicializarTickerInfinito);

  document.addEventListener('shopify:section:load', function(evento) {
    var contenedor = evento.target.querySelector('.seccion-ticker-infinito');
    if (contenedor) inicializarTickerInfinito(contenedor);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["13-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  var secciones = document.querySelectorAll('.avm-encabezado');

  secciones.forEach(function (seccion) {
    var botonAbrir = seccion.querySelector('[data-avm-abrir-menu]');
    var botonCerrar = seccion.querySelector('[data-avm-cerrar-menu]');
    var overlay = seccion.querySelector('[data-avm-overlay]');
    var panel = seccion.querySelector('[data-avm-panel]');

    function abrirMenu() {
      panel.classList.add('avm-esta-activo');
      overlay.classList.add('avm-esta-activo');
      document.body.style.overflow = 'hidden';
    }

    function cerrarMenu() {
      panel.classList.remove('avm-esta-activo');
      overlay.classList.remove('avm-esta-activo');
      document.body.style.overflow = '';
    }

    if (botonAbrir) {
      botonAbrir.addEventListener('click', abrirMenu);
    }
    if (botonCerrar) {
      botonCerrar.addEventListener('click', cerrarMenu);
    }
    if (overlay) {
      overlay.addEventListener('click', cerrarMenu);
    }

    /* ===== Grupos desplegables dentro del panel mobile ===== */
    var gruposMobile = seccion.querySelectorAll('[data-avm-panel-grupo]');
    gruposMobile.forEach(function (grupo) {
      var toggle = grupo.querySelector('[data-avm-panel-grupo-toggle]');
      toggle.addEventListener('click', function () {
        grupo.classList.toggle('avm-esta-abierto');
      });
    });

    /* ===== Menús desplegables de escritorio (categorías/colecciones) ===== */
    var menuItems = seccion.querySelectorAll('[data-avm-menu-item]');

    function cerrarTodosLosMenus() {
      menuItems.forEach(function (item) {
        item.classList.remove('avm-esta-abierto');
      });
    }

    menuItems.forEach(function (item) {
      var toggle = item.querySelector('[data-avm-menu-toggle]');
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var yaEstabaAbierto = item.classList.contains('avm-esta-abierto');
        cerrarTodosLosMenus();
        if (!yaEstabaAbierto) {
          item.classList.add('avm-esta-abierto');
        }
      });
    });

    document.addEventListener('click', function (e) {
      var dentroDeAlgunMenu = e.target.closest('[data-avm-menu-item]');
      if (!dentroDeAlgunMenu) {
        cerrarTodosLosMenus();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        cerrarTodosLosMenus();
      }
    });
  });

  /* ===== Conexión con el carrito lateral nativo de Dawn ===== */
  var botonCarritoDawn = document.getElementById('avm-abrir-carrito-dawn');

  if (botonCarritoDawn) {
    botonCarritoDawn.addEventListener('click', function (e) {
      e.preventDefault();

      var cartDrawer = document.querySelector('cart-drawer');
      var cartNotification = document.querySelector('cart-notification');

      if (cartDrawer && typeof cartDrawer.open === 'function') {
        // Dawn con carrito tipo "Cajón" (drawer)
        cartDrawer.open();
      } else if (cartNotification) {
        // Dawn con carrito tipo "Notificación" — se abre pidiendo el cart.js
        fetch('/cart.js')
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            if (typeof cartNotification.renderContents === 'function') {
              cartNotification.renderContents(cart);
            } else {
              window.location.href = '{{ routes.cart_url }}';
            }
          })
          .catch(function () {
            window.location.href = '{{ routes.cart_url }}';
          });
      } else {
        // Dawn con carrito tipo "Página" — no hay drawer, vamos a la página normal
        window.location.href = '{{ routes.cart_url }}';
      }
    });
  }

  /* ===== FIX: contador del carrito sincronizado en TODOS los casos, SIN =====*/
  /* pisar el valor correcto que ya viene renderizado por Liquid en cada carga */
  /* de página nueva.                                                          */
  /*                                                                            */
  /* El buzón #cart-icon-bubble solo lo llena Shopify vía AJAX cuando ocurre    */
  /* un cambio real de carrito (agregar/quitar/cambiar cantidad) DURANTE la    */
  /* sesión actual de la página. En cada carga nueva de página, ese buzón      */
  /* nace vacío siempre — eso NO significa que el carrito esté vacío.          */
  /*                                                                            */
  /* Por eso, la sincronización desde el buzón (incluyendo el "si no se        */
  /* encuentra el elemento, asumir 0 productos") solo debe dispararse cuando   */
  /* el MutationObserver detecta un cambio real, nunca en el instante en que   */
  /* la página termina de cargar.                                             */
  var contadorVisible = document.getElementById('avm-carrito-contador-dawn');
  var buzonCartIconBubble = document.getElementById('cart-icon-bubble');

  function sincronizarContadorDesdeBuzon() {
    if (!contadorVisible || !buzonCartIconBubble) return;
    var elementoConteo = buzonCartIconBubble.querySelector('[aria-hidden="true"]');
    if (elementoConteo) {
      var numero = parseInt(elementoConteo.textContent, 10);
      contadorVisible.textContent = isNaN(numero) ? '0' : numero;
    } else {
      /* Solo llegamos aquí cuando el observer detectó una mutación real del
         buzón y, tras esa mutación, no quedó ningún elemento de conteo dentro
         — es decir, Shopify de verdad vació el carrito. Como esta función ya
         NO se llama en la carga inicial de la página, este "asumir 0" nunca
         pisa el valor correcto que trae {{ cart.item_count }} al entrar a una
         página nueva. */
      contadorVisible.textContent = '0';
    }
  }

  if (buzonCartIconBubble && window.MutationObserver) {
    var observadorCarrito = new MutationObserver(sincronizarContadorDesdeBuzon);
    observadorCarrito.observe(buzonCartIconBubble, { childList: true, subtree: true });
  }

  /* IMPORTANTE: ya NO se llama sincronizarContadorDesdeBuzon() aquí al cargar
     la página. El badge ya nace con el valor correcto gracias a
     {{ cart.item_count }} renderizado por Liquid, y el buzón vacío en la carga
     inicial NO es una señal confiable de que el carrito esté vacío. */

  /* Se mantiene como respaldo para el "Añadir al carrito" clásico de Dawn */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.tagName === 'FORM' && form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add') !== -1) {
      setTimeout(function () {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            if (contadorVisible) {
              contadorVisible.textContent = cart.item_count;
            }
          });
      }, 800);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["15-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var secciones = document.querySelectorAll('.avm-pie');

  secciones.forEach(function (seccion) {
    var botones = seccion.querySelectorAll('[data-avm-toggle-politicas]');

    botones.forEach(function (boton) {
      var columna = boton.closest('.avm-pie__columna-politicas');
      if (!columna) return;

      var lista = columna.querySelector('[data-avm-lista-politicas]');
      var icono = columna.querySelector('[data-avm-icono-politicas]');

      if (!lista) return;

      boton.addEventListener('click', function () {
        var estaAbierto = lista.classList.contains('avm-esta-activo');

        if (estaAbierto) {
          lista.classList.remove('avm-esta-activo');
          icono.classList.remove('avm-esta-activo');
        } else {
          lista.classList.add('avm-esta-activo');
          icono.classList.add('avm-esta-activo');
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["18-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  var secciones = document.querySelectorAll('[id^="wl-popup-fondo-"]');

  secciones.forEach(function (fondo) {
    var idSeccion = fondo.id.replace('wl-popup-fondo-', '');
    var claveCookie = 'wl_popup_cerrado_' + idSeccion;
    var contenedor = fondo.querySelector('.wl-popup-contenedor');
    var tieneImagen = fondo.querySelector('.wl-popup-imagen');

    if (tieneImagen && contenedor) {
      contenedor.classList.add('wl-popup-con-imagen');
    }

    function yaFueCerrado() {
      return document.cookie.indexOf(claveCookie + '=1') !== -1;
    }

    function marcarComoCerrado(diasDuracion) {
      var fecha = new Date();
      fecha.setTime(fecha.getTime() + diasDuracion * 24 * 60 * 60 * 1000);
      document.cookie = claveCookie + '=1; expires=' + fecha.toUTCString() + '; path=/';
    }

    function cerrarPopup() {
      fondo.classList.remove('wl-popup-visible');
      document.body.style.overflow = '';
      marcarComoCerrado(parseInt(fondo.dataset.wlDuracion || '7', 10));
    }

    function abrirPopup() {
      if (yaFueCerrado()) return;
      fondo.classList.add('wl-popup-visible');
      document.body.style.overflow = 'hidden';
    }

    var botonCerrar = fondo.querySelector('[data-wl-popup-cerrar]');
    if (botonCerrar) {
      botonCerrar.addEventListener('click', cerrarPopup);
    }

    fondo.addEventListener('click', function (evento) {
      if (evento.target === fondo) {
        cerrarPopup();
      }
    });

    var diaInput = fondo.querySelector('[data-wl-popup-dia]');
    var mesInput = fondo.querySelector('[data-wl-popup-mes]');
    var anioInput = fondo.querySelector('[data-wl-popup-anio]');
    var notaInput = fondo.querySelector('input[id^="wl-popup-nota-"]');
    var formulario = fondo.querySelector('.wl-popup-formulario');

    if (formulario && notaInput) {
      formulario.addEventListener('submit', function () {
        var dia = diaInput ? diaInput.value : '';
        var mes = mesInput ? mesInput.value : '';
        var anio = anioInput ? anioInput.value : '';
        if (dia || mes || anio) {
          notaInput.value = 'Cumpleaños: ' + dia + '/' + mes + '/' + anio;
        }
      });
    }

    var retrasoSegundos = parseFloat(fondo.style.getPropertyValue('--wl-popup-delay')) || 3;
    window.setTimeout(abrirPopup, retrasoSegundos * 1000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["7-carrusel-colecciones"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-carrusel-categorias-circulares-envoltorio]').forEach(function (envoltorio) {
      var lista = envoltorio.querySelector('[data-carrusel-categorias-circulares-lista]');
      var siguiente = envoltorio.querySelector('[data-carrusel-categorias-circulares-siguiente]');
      var anterior = envoltorio.querySelector('[data-carrusel-categorias-circulares-anterior]');
      if (!lista) return;

      // --- Flechas (desktop) ---
      if (siguiente) {
        siguiente.addEventListener('click', function () {
          var item = lista.querySelector('li');
          var desplazamiento = item ? item.offsetWidth + 24 : 200;
          lista.scrollBy({ left: desplazamiento, behavior: 'smooth' });
        });
      }
      if (anterior) {
        anterior.addEventListener('click', function () {
          var item = lista.querySelector('li');
          var desplazamiento = item ? item.offsetWidth + 24 : 200;
          lista.scrollBy({ left: -desplazamiento, behavior: 'smooth' });
        });
      }

      // --- Arrastre solo con MOUSE (el dedo usa el scroll nativo del navegador) ---
      var estaArrastrando = false;
      var seMovio = false;
      var puntoInicioX = 0;
      var scrollInicio = 0;
      var UMBRAL_MOVIMIENTO = 5;

      lista.addEventListener('mousedown', function (evento) {
        if (evento.button !== 0) return; // solo click izquierdo
        estaArrastrando = true;
        seMovio = false;
        puntoInicioX = evento.clientX;
        scrollInicio = lista.scrollLeft;
        lista.classList.add('esta-arrastrando');
      });

      window.addEventListener('mousemove', function (evento) {
        if (!estaArrastrando) return;
        var delta = evento.clientX - puntoInicioX;
        if (Math.abs(delta) > UMBRAL_MOVIMIENTO) seMovio = true;
        if (seMovio) {
          evento.preventDefault();
          lista.scrollLeft = scrollInicio - delta;
        }
      });

      window.addEventListener('mouseup', function () {
        if (!estaArrastrando) return;
        estaArrastrando = false;
        lista.classList.remove('esta-arrastrando');
        // Libera el bloqueo de clicks un instante después de soltar
        if (seMovio) {
          setTimeout(function () { seMovio = false; }, 0);
        }
      });

      // Evita que el click en el enlace navegue justo después de haber arrastrado con el mouse
      lista.addEventListener('click', function (evento) {
        if (seMovio) {
          evento.preventDefault();
          evento.stopPropagation();
          seMovio = false;
        }
      }, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["8-tarjetas-producto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-coleccion-destacada]').forEach(function (seccion) {
      var modal = seccion.querySelector('[data-coleccion-destacada-modal]');
      var cuerpo = seccion.querySelector('[data-coleccion-destacada-modal-cuerpo]');
      if (!modal || !cuerpo) return;

      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }

      function cerrarModal() {
        if (typeof modal.close === 'function') {
          modal.close();
        } else {
          modal.removeAttribute('open');
        }
        cuerpo.innerHTML = '';
      }

      modal.addEventListener('click', function (evento) {
        if (evento.target === modal) cerrarModal();
      });

      modal.addEventListener('close', function () {
        cuerpo.innerHTML = '';
      });

      modal.querySelectorAll('[data-coleccion-destacada-modal-cerrar]').forEach(function (elemento) {
        elemento.addEventListener('click', cerrarModal);
      });

      var mapaColores = {
        'rosa gold': '#B76E79', 'rose gold': '#B76E79', 'oro rosa': '#B76E79',
        'dorado': '#C9A265', 'gold': '#C9A265', 'oro': '#C9A265',
        'plateado': '#C0C0C0', 'silver': '#C0C0C0', 'plata': '#C0C0C0',
        'blanco': '#F5F1EA', 'white': '#F5F1EA', 'perla': '#F5F1EA', 'pearl': '#F5F1EA',
        'negro': '#000000', 'black': '#000000',
        'celeste': '#A7D8F0', 'sky': '#A7D8F0', 'azul claro': '#A7D8F0',
        'azul': '#3B5998', 'blue': '#3B5998', 'navy': '#3B5998',
        'butter yellow': '#F3E5A7',
        'rosado': '#E8A0BF', 'rosa': '#E8A0BF', 'pink': '#E8A0BF', 'fucsia': '#E8A0BF',
        'burgundy': '#6E1423', 'burdeos': '#6E1423', 'vino': '#6E1423',
        'coral': '#E67E22',
        'rojo': '#8B2E2E', 'red': '#8B2E2E',
        'verde': '#2E8B57', 'green': '#2E8B57', 'oliva': '#2E8B57',
        'morado': '#7D3C98', 'purple': '#7D3C98', 'violeta': '#7D3C98', 'lila': '#7D3C98',
        'beige': '#E8DCC8', 'nude': '#E8DCC8', 'crema': '#E8DCC8',
        'cafe': '#6B4226', 'café': '#6B4226', 'marron': '#6B4226', 'marrón': '#6B4226', 'brown': '#6B4226', 'chocolate': '#6B4226',
        'gris': '#9A9A9A', 'gray': '#9A9A9A', 'grey': '#9A9A9A', 'plomo': '#9A9A9A',
        'amarillo': '#F1C40F', 'yellow': '#F1C40F', 'mostaza': '#F1C40F',
        'naranja': '#E67E22', 'orange': '#E67E22',
        'turquesa': '#2FBFA6', 'turquoise': '#2FBFA6', 'aqua': '#2FBFA6',
        'palo rosa': '#E7C7C2'
      };

      function obtenerColorHex(nombreValor) {
        var nombre = nombreValor.toLowerCase();
        for (var clave in mapaColores) {
          if (nombre.indexOf(clave) !== -1) return mapaColores[clave];
        }
        return '#cccccc';
      }

      function construirControlesOpciones(producto, mapaColoresReal) {
        mapaColoresReal = mapaColoresReal || {};
        if (producto.variants.length <= 1 && producto.options.length === 1) {
          var unicaOpcion = producto.options[0];
          var unicoNombre = (typeof unicaOpcion === 'object' && unicaOpcion !== null) ? unicaOpcion.name : unicaOpcion;
          if (/^title$/i.test(unicoNombre)) return '';
        }
        return producto.options.map(function (opcion, indice) {
          var nombreOpcion = (typeof opcion === 'object' && opcion !== null) ? opcion.name : opcion;
          var esColor = /color/i.test(nombreOpcion);
          var valores = [];
          producto.variants.forEach(function (variante) {
            var valor = variante.options[indice];
            if (valores.indexOf(valor) === -1) valores.push(valor);
          });

          if (esColor) {
            var swatchesHtml = valores.map(function (valor, i) {
              var colorReal = mapaColoresReal[valor] || obtenerColorHex(valor);
              return '<button type="button" class="coleccion-destacada__mv-swatch" data-indice-opcion="' + indice + '" data-valor-opcion="' + valor + '" style="background:' + colorReal + ';" title="' + valor + '"></button>';
            }).join('');
            return '<div class="coleccion-destacada__mv-opcion"><span class="coleccion-destacada__mv-opcion-nombre">Color:<span data-mv-color-seleccionado></span></span><div class="coleccion-destacada__mv-swatches" data-swatches-opcion="' + indice + '">' + swatchesHtml + '</div></div>';
          }

          var opcionesHtml = valores.map(function (valor) {
            return '<option value="' + valor + '">' + valor + '</option>';
          }).join('');
          return '<div class="coleccion-destacada__mv-opcion"><span class="coleccion-destacada__mv-opcion-nombre">' + nombreOpcion + '</span><select class="coleccion-destacada__mv-select" data-indice-opcion="' + indice + '">' + opcionesHtml + '</select></div>';
        }).join('');
      }

      function encontrarVariante(producto, seleccion) {
        return producto.variants.find(function (variante) {
          return seleccion.every(function (valor, indice) {
            return variante.options[indice] === valor;
          });
        });
      }

      function formatearPrecio(centavos, moneda) {
        return (centavos / 100).toLocaleString('es-CO', { style: 'currency', currency: moneda || 'COP' });
      }

      function obtenerPieModal() {
        var plantilla = document.querySelector('[data-plantilla-pie-modal]');
        return plantilla ? plantilla.innerHTML : '';
      }

      function vigilarCierreDeCarrito(elementoCartDrawer) {
        document.documentElement.classList.add('overflow-hidden');

        var observador = new MutationObserver(function () {
          if (!elementoCartDrawer.classList.contains('active')) {
            document.documentElement.classList.remove('overflow-hidden');
            observador.disconnect();
          }
        });

        observador.observe(elementoCartDrawer, { attributes: true, attributeFilter: ['class'] });
      }

      var caracteristicas = [
        {
          icono: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"></path><line x1="16" y1="8" x2="2" y2="22"></line><line x1="17.5" y1="15" x2="9" y2="15"></line></svg>',
          texto: seccion.getAttribute('data-caracteristica-1')
        },
        {
          icono: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.69s6 6.4 6 10.31a6 6 0 0 1-12 0c0-3.91 6-10.31 6-10.31z"></path></svg>',
          texto: seccion.getAttribute('data-caracteristica-2')
        },
        {
          icono: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M18 11V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v5"></path><path d="M14 10V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v6"></path><path d="M10 10.5V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v8"></path><path d="M6 14v-2a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v3a8 8 0 0 0 8 8h2a8 8 0 0 0 8-8v-3"></path></svg>',
          texto: seccion.getAttribute('data-caracteristica-3')
        }
      ].filter(function (item) { return item.texto; });

      function abrirModal(url, insigniaNuevo, mapaColoresRealJson) {
        var mapaColoresReal = {};
        if (mapaColoresRealJson) {
          try {
            mapaColoresReal = JSON.parse(mapaColoresRealJson);
          } catch (errorParseo) {
            mapaColoresReal = {};
          }
        }

        cuerpo.innerHTML = '<p class="coleccion-destacada__mv-mensaje">Cargando...</p>';
        if (typeof modal.showModal === 'function') {
          modal.showModal();
        } else {
          modal.setAttribute('open', '');
        }

        fetch(url.split('?')[0] + '.js')
          .then(function (respuesta) { return respuesta.json(); })
          .then(function (producto) {
            var imagenes = (producto.images && producto.images.length) ? producto.images : [producto.featured_image];
            var indiceImagen = 0;

            var flechasHtml = imagenes.length > 1 ?
              '<button type="button" class="coleccion-destacada__mv-flecha coleccion-destacada__mv-flecha--anterior" data-mv-anterior aria-label="Imagen anterior"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 6 9 12 15 18"></polyline></svg></button>' +
              '<button type="button" class="coleccion-destacada__mv-flecha coleccion-destacada__mv-flecha--siguiente" data-mv-siguiente aria-label="Imagen siguiente"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"></polyline></svg></button>'
              : '';

            var insigniaHtml = insigniaNuevo ? '<span class="coleccion-destacada__mv-insignia">' + insigniaNuevo + '</span>' : '';

            cuerpo.innerHTML =
              '<div class="coleccion-destacada__mv-envoltorio">' +
                '<div class="coleccion-destacada__mv-galeria">' +
                  insigniaHtml +
                  '<img class="coleccion-destacada__mv-imagen" data-mv-imagen src="' + imagenes[0] + '" alt="' + producto.title + '">' +
                  flechasHtml +
                '</div>' +
                '<div class="coleccion-destacada__mv-info">' +
                  '<div class="coleccion-destacada__mv-estrellas-fila" data-mv-valoracion></div>' +
                  '<p class="coleccion-destacada__mv-titulo">' + producto.title + '</p>' +
                  '<p class="coleccion-destacada__mv-precio" data-mv-precio></p>' +
                  '<div class="coleccion-destacada__mv-caracteristicas">' +
                    caracteristicas.map(function (item) {
                      return '<div class="coleccion-destacada__mv-caracteristica">' + item.icono + '<span>' + item.texto + '</span></div>';
                    }).join('') +
                  '</div>' +
                  '<div data-mv-opciones>' + construirControlesOpciones(producto, mapaColoresReal) + '</div>' +
                  '<div class="coleccion-destacada__mv-fila-acciones">' +
                    '<div class="coleccion-destacada__mv-cantidad">' +
                      '<button type="button" class="coleccion-destacada__mv-cantidad-boton" data-mv-restar aria-label="Restar">−</button>' +
                      '<span class="coleccion-destacada__mv-cantidad-valor" data-mv-cantidad>1</span>' +
                      '<button type="button" class="coleccion-destacada__mv-cantidad-boton" data-mv-sumar aria-label="Sumar">+</button>' +
                    '</div>' +
                    '<button type="button" class="coleccion-destacada__mv-boton-agregar" data-mv-agregar>Agregar al carrito</button>' +
                  '</div>' +
                  '<button type="button" class="coleccion-destacada__mv-boton-comprar" data-mv-comprar>Comprar ahora</button>' +
                  obtenerPieModal() +
                  '<p class="coleccion-destacada__mv-mensaje" data-mv-mensaje></p>' +
                '</div>' +
              '</div>';

            if (window.MutationObserver) {
              // sin uso, reservado
            }

            var imagenElemento = cuerpo.querySelector('[data-mv-imagen]');
            var botonAnterior = cuerpo.querySelector('[data-mv-anterior]');
            var botonSiguiente = cuerpo.querySelector('[data-mv-siguiente]');
            var selects = cuerpo.querySelectorAll('select[data-indice-opcion]');
            var gruposSwatches = cuerpo.querySelectorAll('[data-swatches-opcion]');
            var precioElemento = cuerpo.querySelector('[data-mv-precio]');
            var botonAgregar = cuerpo.querySelector('[data-mv-agregar]');
            var botonComprar = cuerpo.querySelector('[data-mv-comprar]');
            var mensajeElemento = cuerpo.querySelector('[data-mv-mensaje]');
            var cantidadElemento = cuerpo.querySelector('[data-mv-cantidad]');
            var botonRestar = cuerpo.querySelector('[data-mv-restar]');
            var botonSumar = cuerpo.querySelector('[data-mv-sumar]');
            var valoracionElemento = cuerpo.querySelector('[data-mv-valoracion]');

            if (botonAnterior) {
              botonAnterior.addEventListener('click', function () {
                indiceImagen = (indiceImagen - 1 + imagenes.length) % imagenes.length;
                imagenElemento.setAttribute('src', imagenes[indiceImagen]);
              });
            }
            if (botonSiguiente) {
              botonSiguiente.addEventListener('click', function () {
                indiceImagen = (indiceImagen + 1) % imagenes.length;
                imagenElemento.setAttribute('src', imagenes[indiceImagen]);
              });
            }

            var valoracion = producto.metafields && producto.metafields.reviews && producto.metafields.reviews.rating ? producto.metafields.reviews.rating.value : 5;
            var totalValoraciones = producto.metafields && producto.metafields.reviews ? producto.metafields.reviews.rating_count : 0;
            if (valoracionElemento) {
              valoracionElemento.innerHTML = '<span class="coleccion-destacada__mv-estrellas" style="--coleccion-destacada-mv-porcentaje-estrellas:' + (valoracion * 20) + '%;">★★★★★</span>' + (totalValoraciones ? '<span class="coleccion-destacada__mv-total-valoraciones">(' + totalValoraciones + ')</span>' : '');
            }

            var cantidadActual = 1;
            if (botonRestar) {
              botonRestar.addEventListener('click', function () {
                if (cantidadActual > 1) cantidadActual -= 1;
                cantidadElemento.textContent = cantidadActual;
              });
            }
            if (botonSumar) {
              botonSumar.addEventListener('click', function () {
                cantidadActual += 1;
                cantidadElemento.textContent = cantidadActual;
              });
            }

            function obtenerSeleccion() {
              var seleccion = [];
              producto.options.forEach(function (_, indice) {
                var select = cuerpo.querySelector('select[data-indice-opcion="' + indice + '"]');
                if (select) {
                  seleccion[indice] = select.value;
                  return;
                }
                var swatchActivo = cuerpo.querySelector('[data-swatches-opcion="' + indice + '"] .coleccion-destacada__mv-swatch--activo');
                if (swatchActivo) {
                  seleccion[indice] = swatchActivo.getAttribute('data-valor-opcion');
                  return;
                }
                var primerSwatch = cuerpo.querySelector('[data-swatches-opcion="' + indice + '"] .coleccion-destacada__mv-swatch');
                if (primerSwatch) {
                  seleccion[indice] = primerSwatch.getAttribute('data-valor-opcion');
                  return;
                }
                var varianteDefecto = producto.variants[0];
                seleccion[indice] = varianteDefecto ? varianteDefecto.options[indice] : null;
              });
              return seleccion;
            }

            function actualizarVariante() {
              var requiereColor = gruposSwatches.length > 0;
              var hayColorSeleccionado = requiereColor ? cuerpo.querySelector('.coleccion-destacada__mv-swatch--activo') !== null : true;

              if (requiereColor && !hayColorSeleccionado) {
                precioElemento.textContent = formatearPrecio(producto.price, producto.currency);
                botonAgregar.disabled = true;
                botonComprar.disabled = true;
                botonAgregar.textContent = 'Elige un color';
                return;
              }

              var variante = encontrarVariante(producto, obtenerSeleccion());
              if (variante) {
                precioElemento.textContent = formatearPrecio(variante.price, producto.currency);
                var disponible = variante.available;
                botonAgregar.disabled = !disponible;
                botonComprar.disabled = !disponible;
                botonAgregar.textContent = disponible ? 'Agregar al carrito' : 'Agotado';
                botonAgregar.setAttribute('data-variante-id', variante.id);
                botonComprar.setAttribute('data-variante-id', variante.id);
              }
            }

            selects.forEach(function (select) {
              select.addEventListener('change', actualizarVariante);
            });

            gruposSwatches.forEach(function (grupo) {
              var botones = grupo.querySelectorAll('.coleccion-destacada__mv-swatch');
              var etiqueta = grupo.parentElement.querySelector('[data-mv-color-seleccionado]');
              botones.forEach(function (boton) {
                boton.addEventListener('click', function () {
                  botones.forEach(function (b) { b.classList.remove('coleccion-destacada__mv-swatch--activo'); });
                  boton.classList.add('coleccion-destacada__mv-swatch--activo');
                  if (etiqueta) etiqueta.textContent = ' ' + boton.getAttribute('data-valor-opcion');

                  var indiceOpcionColor = parseInt(boton.getAttribute('data-indice-opcion'), 10);
                  var valorColor = boton.getAttribute('data-valor-opcion');
                  var varianteDelColor = producto.variants.find(function (v) { return v.options[indiceOpcionColor] === valorColor; });
                  if (varianteDelColor && varianteDelColor.featured_image && varianteDelColor.featured_image.src) {
                    var indiceEnGaleria = imagenes.indexOf(varianteDelColor.featured_image.src);
                    if (indiceEnGaleria === -1) {
                      imagenes = [varianteDelColor.featured_image.src].concat(imagenes);
                      indiceEnGaleria = 0;
                    }
                    indiceImagen = indiceEnGaleria;
                    imagenElemento.setAttribute('src', varianteDelColor.featured_image.src);
                  } else {
                    indiceImagen = 0;
                    imagenElemento.setAttribute('src', imagenes[0]);
                  }

                  actualizarVariante();
                });
              });
            });

            actualizarVariante();

            botonAgregar.addEventListener('click', function () {
              var varianteId = botonAgregar.getAttribute('data-variante-id');
              if (!varianteId) return;
              mensajeElemento.textContent = 'Añadiendo...';
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: varianteId,
                  quantity: cantidadActual,
                  sections: ['cart-drawer'],
                  sections_url: window.location.pathname
                })
              })
                .then(function (respuesta) { return respuesta.json(); })
                .then(function (datosRespuesta) {
                  cerrarModal();

                  try {
                    var htmlSeccion = datosRespuesta.sections && datosRespuesta.sections['cart-drawer'];
                    var elementoActual = document.querySelector('cart-drawer');

                    if (htmlSeccion && elementoActual) {
                      var parser = new DOMParser();
                      var documentoNuevo = parser.parseFromString(htmlSeccion, 'text/html');
                      var elementoNuevo = documentoNuevo.querySelector('cart-drawer');

                      if (elementoNuevo) {
                        elementoActual.outerHTML = elementoNuevo.outerHTML;
                        var elementoActualizado = document.querySelector('cart-drawer');

                        requestAnimationFrame(function () {
                          elementoActualizado.classList.add('animate', 'active');
                        });
                        document.documentElement.classList.add('overflow-hidden');
                        vigilarCierreDeCarrito(elementoActualizado);
                      } else {
                        window.location.href = '/cart';
                      }
                    } else {
                      window.location.href = '/cart';
                    }
                  } catch (errorRenderizado) {
                    window.location.href = '/cart';
                  }
                })
                .catch(function () {
                  window.location.href = '/cart';
                });
            });

            botonComprar.addEventListener('click', function () {
              var varianteId = botonComprar.getAttribute('data-variante-id');
              if (!varianteId) return;
              mensajeElemento.textContent = 'Redirigiendo al pago...';
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: varianteId, quantity: cantidadActual })
              })
                .then(function () {
                  window.location.href = '/checkout';
                })
                .catch(function () {
                  mensajeElemento.textContent = 'Hubo un problema al procesar la compra.';
                });
            });
          })
          .catch(function () {
            cuerpo.innerHTML = '<p class="coleccion-destacada__mv-mensaje">No se pudo cargar el producto.</p>';
          });
      }

      seccion.querySelectorAll('[data-coleccion-destacada-compra-rapida]').forEach(function (disparador) {
        disparador.addEventListener('click', function (evento) {
          evento.preventDefault();
          evento.stopPropagation();
          abrirModal(disparador.getAttribute('data-producto-url'), disparador.getAttribute('data-insignia-nuevo'), disparador.getAttribute('data-colores-mapa'));
        });
        disparador.addEventListener('keydown', function (evento) {
          if (evento.key === 'Enter' || evento.key === ' ') {
            evento.preventDefault();
            abrirModal(disparador.getAttribute('data-producto-url'), disparador.getAttribute('data-insignia-nuevo'), disparador.getAttribute('data-colores-mapa'));
          }
        });
      });

      seccion.querySelectorAll('[data-coleccion-destacada-tarjeta]').forEach(function (tarjeta) {
        var swatches = tarjeta.querySelectorAll('[data-coleccion-destacada-swatch]');
        var enlaceImagen = tarjeta.querySelector('[data-coleccion-destacada-enlace-imagen]');
        var enlaceNombre = tarjeta.querySelector('[data-coleccion-destacada-enlace-nombre]');
        var imagenPrincipal = tarjeta.querySelector('[data-coleccion-destacada-imagen-principal]');
        var compraRapida = tarjeta.querySelector('[data-coleccion-destacada-compra-rapida]');
        var imagenOriginal = imagenPrincipal ? imagenPrincipal.getAttribute('src') : null;

        swatches.forEach(function (swatch) {
          swatch.addEventListener('click', function (evento) {
            evento.preventDefault();
            evento.stopPropagation();

            swatches.forEach(function (otro) {
              otro.classList.remove('coleccion-destacada__color--activo');
            });
            swatch.classList.add('coleccion-destacada__color--activo');

            var urlVariante = swatch.getAttribute('data-variante-url');
            var imagenVariante = swatch.getAttribute('data-variante-imagen');

            if (urlVariante) {
              if (enlaceImagen) enlaceImagen.setAttribute('href', urlVariante);
              if (enlaceNombre) enlaceNombre.setAttribute('href', urlVariante);
              if (compraRapida) compraRapida.setAttribute('data-producto-url', urlVariante);
            }

            if (imagenPrincipal) {
              imagenPrincipal.setAttribute('src', imagenVariante || imagenOriginal);
              imagenPrincipal.removeAttribute('srcset');
            }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["9-coleccion-categorias"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-coleccion-destacada]').forEach(function (seccion) {
      var modal = seccion.querySelector('[data-coleccion-destacada-modal]');
      var cuerpo = seccion.querySelector('[data-coleccion-destacada-modal-cuerpo]');
      if (!modal || !cuerpo) return;

      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }

      function cerrarModal() {
        if (typeof modal.close === 'function') {
          modal.close();
        } else {
          modal.removeAttribute('open');
        }
        cuerpo.innerHTML = '';
      }

      modal.addEventListener('click', function (evento) {
        if (evento.target === modal) cerrarModal();
      });

      modal.addEventListener('close', function () {
        cuerpo.innerHTML = '';
      });

      modal.querySelectorAll('[data-coleccion-destacada-modal-cerrar]').forEach(function (elemento) {
        elemento.addEventListener('click', cerrarModal);
      });

      var mapaColores = {
        'rosa gold': '#B76E79', 'rose gold': '#B76E79', 'oro rosa': '#B76E79',
        'dorado': '#C9A265', 'gold': '#C9A265', 'oro': '#C9A265',
        'plateado': '#C0C0C0', 'silver': '#C0C0C0', 'plata': '#C0C0C0',
        'blanco': '#F5F1EA', 'white': '#F5F1EA', 'perla': '#F5F1EA', 'pearl': '#F5F1EA',
        'negro': '#000000', 'black': '#000000',
        'celeste': '#A7D8F0', 'sky': '#A7D8F0', 'azul claro': '#A7D8F0',
        'azul': '#3B5998', 'blue': '#3B5998', 'navy': '#3B5998',
        'butter yellow': '#F3E5A7',
        'rosado': '#E8A0BF', 'rosa': '#E8A0BF', 'pink': '#E8A0BF', 'fucsia': '#E8A0BF',
        'burgundy': '#6E1423', 'burdeos': '#6E1423', 'vino': '#6E1423',
        'coral': '#E67E22', 'rojo': '#8B2E2E', 'red': '#8B2E2E',
        'verde': '#2E8B57', 'green': '#2E8B57', 'oliva': '#2E8B57',
        'morado': '#7D3C98', 'purple': '#7D3C98', 'violeta': '#7D3C98', 'lila': '#7D3C98',
        'beige': '#E8DCC8', 'nude': '#E8DCC8', 'crema': '#E8DCC8',
        'cafe': '#6B4226', 'café': '#6B4226', 'marron': '#6B4226', 'marrón': '#6B4226', 'brown': '#6B4226', 'chocolate': '#6B4226',
        'gris': '#9A9A9A', 'gray': '#9A9A9A', 'grey': '#9A9A9A', 'plomo': '#9A9A9A',
        'amarillo': '#F1C40F', 'yellow': '#F1C40F', 'mostaza': '#F1C40F',
        'naranja': '#E67E22', 'orange': '#E67E22',
        'turquesa': '#2FBFA6', 'turquoise': '#2FBFA6', 'aqua': '#2FBFA6',
        'palo rosa': '#E7C7C2'
      };

      function obtenerColorHex(nombreValor) {
        var nombre = nombreValor.toLowerCase();
        for (var clave in mapaColores) {
          if (nombre.indexOf(clave) !== -1) return mapaColores[clave];
        }
        return '#cccccc';
      }

      function construirControlesOpciones(producto, mapaColoresReal) {
        mapaColoresReal = mapaColoresReal || {};
        if (producto.variants.length <= 1 && producto.options.length === 1) {
          var unicaOpcion = producto.options[0];
          var unicoNombre = (typeof unicaOpcion === 'object' && unicaOpcion !== null) ? unicaOpcion.name : unicaOpcion;
          if (/^title$/i.test(unicoNombre)) return '';
        }
        return producto.options.map(function (opcion, indice) {
          var nombreOpcion = (typeof opcion === 'object' && opcion !== null) ? opcion.name : opcion;
          var esColor = /color/i.test(nombreOpcion);
          var valores = [];
          producto.variants.forEach(function (variante) {
            var valor = variante.options[indice];
            if (valores.indexOf(valor) === -1) valores.push(valor);
          });

          if (esColor) {
            var swatchesHtml = valores.map(function (valor, i) {
              var colorReal = mapaColoresReal[valor] || obtenerColorHex(valor);
              return '<button type="button" class="coleccion-destacada__mv-swatch" data-indice-opcion="' + indice + '" data-valor-opcion="' + valor + '" style="background:' + colorReal + ';" title="' + valor + '"></button>';
            }).join('');
            return '<div class="coleccion-destacada__mv-opcion"><span class="coleccion-destacada__mv-opcion-nombre">Color:<span data-mv-color-seleccionado></span></span><div class="coleccion-destacada__mv-swatches" data-swatches-opcion="' + indice + '">' + swatchesHtml + '</div></div>';
          }

          var opcionesHtml = valores.map(function (valor) {
            return '<option value="' + valor + '">' + valor + '</option>';
          }).join('');
          return '<div class="coleccion-destacada__mv-opcion"><span class="coleccion-destacada__mv-opcion-nombre">' + nombreOpcion + '</span><select class="coleccion-destacada__mv-select" data-indice-opcion="' + indice + '">' + opcionesHtml + '</select></div>';
        }).join('');
      }

      function encontrarVariante(producto, seleccion) {
        return producto.variants.find(function (variante) {
          return seleccion.every(function (valor, indice) {
            return variante.options[indice] === valor;
          });
        });
      }

      function formatearPrecio(centavos, moneda) {
        return (centavos / 100).toLocaleString('es-CO', { style: 'currency', currency: moneda || 'COP' });
      }

      function obtenerPieModal() {
        var plantilla = document.querySelector('[data-plantilla-pie-modal]');
        return plantilla ? plantilla.innerHTML : '';
      }

      function vigilarCierreDeCarrito(elementoCartDrawer) {
        document.documentElement.classList.add('overflow-hidden');

        var observador = new MutationObserver(function () {
          if (!elementoCartDrawer.classList.contains('active')) {
            document.documentElement.classList.remove('overflow-hidden');
            observador.disconnect();
          }
        });

        observador.observe(elementoCartDrawer, { attributes: true, attributeFilter: ['class'] });
      }

      var caracteristicas = [
        {
          icono: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"></path><line x1="16" y1="8" x2="2" y2="22"></line><line x1="17.5" y1="15" x2="9" y2="15"></line></svg>',
          texto: seccion.getAttribute('data-caracteristica-1')
        },
        {
          icono: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.69s6 6.4 6 10.31a6 6 0 0 1-12 0c0-3.91 6-10.31 6-10.31z"></path></svg>',
          texto: seccion.getAttribute('data-caracteristica-2')
        },
        {
          icono: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M18 11V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v5"></path><path d="M14 10V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v6"></path><path d="M10 10.5V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v8"></path><path d="M6 14v-2a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v3a8 8 0 0 0 8 8h2a8 8 0 0 0 8-8v-3"></path></svg>',
          texto: seccion.getAttribute('data-caracteristica-3')
        }
      ].filter(function (item) { return item.texto; });

      function abrirModal(url, insigniaNuevo, mapaColoresRealJson, valoracionManual, totalValoracionesManual) {
        var mapaColoresReal = {};
        if (mapaColoresRealJson) {
          try {
            mapaColoresReal = JSON.parse(mapaColoresRealJson);
          } catch (errorParseo) {
            mapaColoresReal = {};
          }
        }
        cuerpo.innerHTML = '<p class="coleccion-destacada__mv-mensaje">Cargando...</p>';
        if (typeof modal.showModal === 'function') {
          modal.showModal();
        } else {
          modal.setAttribute('open', '');
        }

        fetch(url.split('?')[0] + '.js')
          .then(function (respuesta) { return respuesta.json(); })
          .then(function (producto) {
            var imagenes = (producto.images && producto.images.length) ? producto.images : [producto.featured_image];
            var indiceImagen = 0;

            var flechasHtml = imagenes.length > 1 ?
              '<button type="button" class="coleccion-destacada__mv-flecha coleccion-destacada__mv-flecha--anterior" data-mv-anterior aria-label="Imagen anterior"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 6 9 12 15 18"></polyline></svg></button>' +
              '<button type="button" class="coleccion-destacada__mv-flecha coleccion-destacada__mv-flecha--siguiente" data-mv-siguiente aria-label="Imagen siguiente"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"></polyline></svg></button>'
              : '';

            var insigniaHtml = insigniaNuevo ? '<span class="coleccion-destacada__mv-insignia">' + insigniaNuevo + '</span>' : '';

            cuerpo.innerHTML =
              '<div class="coleccion-destacada__mv-envoltorio">' +
                '<div class="coleccion-destacada__mv-galeria">' +
                  insigniaHtml +
                  '<img class="coleccion-destacada__mv-imagen" data-mv-imagen src="' + imagenes[0] + '" alt="' + producto.title + '">' +
                  flechasHtml +
                '</div>' +
                '<div class="coleccion-destacada__mv-info">' +
                  '<div class="coleccion-destacada__mv-estrellas-fila" data-mv-valoracion></div>' +
                  '<p class="coleccion-destacada__mv-titulo">' + producto.title + '</p>' +
                  '<p class="coleccion-destacada__mv-precio" data-mv-precio></p>' +
                  '<div class="coleccion-destacada__mv-caracteristicas">' +
                    caracteristicas.map(function (item) {
                      return '<div class="coleccion-destacada__mv-caracteristica">' + item.icono + '<span>' + item.texto + '</span></div>';
                    }).join('') +
                  '</div>' +
                  '<div data-mv-opciones>' + construirControlesOpciones(producto, mapaColoresReal) + '</div>' +
                  '<div class="coleccion-destacada__mv-fila-acciones">' +
                    '<div class="coleccion-destacada__mv-cantidad">' +
                      '<button type="button" class="coleccion-destacada__mv-cantidad-boton" data-mv-restar aria-label="Restar">−</button>' +
                      '<span class="coleccion-destacada__mv-cantidad-valor" data-mv-cantidad>1</span>' +
                      '<button type="button" class="coleccion-destacada__mv-cantidad-boton" data-mv-sumar aria-label="Sumar">+</button>' +
                    '</div>' +
                    '<button type="button" class="coleccion-destacada__mv-boton-agregar" data-mv-agregar>Agregar al carrito</button>' +
                  '</div>' +
                  '<button type="button" class="coleccion-destacada__mv-boton-comprar" data-mv-comprar>Comprar ahora</button>' +
                  obtenerPieModal() +
                  '<p class="coleccion-destacada__mv-mensaje" data-mv-mensaje></p>' +
                '</div>' +
              '</div>';

            var imagenElemento = cuerpo.querySelector('[data-mv-imagen]');
            var botonAnterior = cuerpo.querySelector('[data-mv-anterior]');
            var botonSiguiente = cuerpo.querySelector('[data-mv-siguiente]');
            var selects = cuerpo.querySelectorAll('select[data-indice-opcion]');
            var gruposSwatches = cuerpo.querySelectorAll('[data-swatches-opcion]');
            var precioElemento = cuerpo.querySelector('[data-mv-precio]');
            var botonAgregar = cuerpo.querySelector('[data-mv-agregar]');
            var botonComprar = cuerpo.querySelector('[data-mv-comprar]');
            var mensajeElemento = cuerpo.querySelector('[data-mv-mensaje]');
            var cantidadElemento = cuerpo.querySelector('[data-mv-cantidad]');
            var botonRestar = cuerpo.querySelector('[data-mv-restar]');
            var botonSumar = cuerpo.querySelector('[data-mv-sumar]');
            var valoracionElemento = cuerpo.querySelector('[data-mv-valoracion]');

            if (botonAnterior) {
              botonAnterior.addEventListener('click', function () {
                indiceImagen = (indiceImagen - 1 + imagenes.length) % imagenes.length;
                imagenElemento.setAttribute('src', imagenes[indiceImagen]);
              });
            }
            if (botonSiguiente) {
              botonSiguiente.addEventListener('click', function () {
                indiceImagen = (indiceImagen + 1) % imagenes.length;
                imagenElemento.setAttribute('src', imagenes[indiceImagen]);
              });
            }

            var valoracion = parseFloat(valoracionManual) || 0;
            var totalValoraciones = parseInt(totalValoracionesManual, 10) || 0;
            if (valoracionElemento) {
              valoracionElemento.innerHTML = totalValoraciones > 0 ? ('<span class="coleccion-destacada__mv-estrellas" style="--coleccion-destacada-mv-porcentaje-estrellas:' + (valoracion * 20) + '%;">★★★★★</span><span class="coleccion-destacada__mv-total-valoraciones">(' + totalValoraciones + ')</span>') : '';
            }

            var cantidadActual = 1;
            if (botonRestar) {
              botonRestar.addEventListener('click', function () {
                if (cantidadActual > 1) cantidadActual -= 1;
                cantidadElemento.textContent = cantidadActual;
              });
            }
            if (botonSumar) {
              botonSumar.addEventListener('click', function () {
                cantidadActual += 1;
                cantidadElemento.textContent = cantidadActual;
              });
            }

            function obtenerSeleccion() {
              var seleccion = [];
              producto.options.forEach(function (_, indice) {
                var select = cuerpo.querySelector('select[data-indice-opcion="' + indice + '"]');
                if (select) {
                  seleccion[indice] = select.value;
                  return;
                }
                var swatchActivo = cuerpo.querySelector('[data-swatches-opcion="' + indice + '"] .coleccion-destacada__mv-swatch--activo');
                if (swatchActivo) {
                  seleccion[indice] = swatchActivo.getAttribute('data-valor-opcion');
                  return;
                }
                var primerSwatch = cuerpo.querySelector('[data-swatches-opcion="' + indice + '"] .coleccion-destacada__mv-swatch');
                if (primerSwatch) {
                  seleccion[indice] = primerSwatch.getAttribute('data-valor-opcion');
                  return;
                }
                var varianteDefecto = producto.variants[0];
                seleccion[indice] = varianteDefecto ? varianteDefecto.options[indice] : null;
              });
              return seleccion;
            }

            function actualizarVariante() {
              var requiereColor = gruposSwatches.length > 0;
              var hayColorSeleccionado = requiereColor ? cuerpo.querySelector('.coleccion-destacada__mv-swatch--activo') !== null : true;

              if (requiereColor && !hayColorSeleccionado) {
                precioElemento.textContent = formatearPrecio(producto.price, producto.currency);
                botonAgregar.disabled = true;
                botonComprar.disabled = true;
                botonAgregar.textContent = 'Elige un color';
                return;
              }

              var variante = encontrarVariante(producto, obtenerSeleccion());
              if (variante) {
                precioElemento.textContent = formatearPrecio(variante.price, producto.currency);
                var disponible = variante.available;
                botonAgregar.disabled = !disponible;
                botonComprar.disabled = !disponible;
                botonAgregar.textContent = disponible ? 'Agregar al carrito' : 'Agotado';
                botonAgregar.setAttribute('data-variante-id', variante.id);
                botonComprar.setAttribute('data-variante-id', variante.id);
              }
            }

            selects.forEach(function (select) {
              select.addEventListener('change', actualizarVariante);
            });

            gruposSwatches.forEach(function (grupo) {
              var botones = grupo.querySelectorAll('.coleccion-destacada__mv-swatch');
              var etiqueta = grupo.parentElement.querySelector('[data-mv-color-seleccionado]');
              botones.forEach(function (boton) {
                boton.addEventListener('click', function () {
                  botones.forEach(function (b) { b.classList.remove('coleccion-destacada__mv-swatch--activo'); });
                  boton.classList.add('coleccion-destacada__mv-swatch--activo');
                  if (etiqueta) etiqueta.textContent = ' ' + boton.getAttribute('data-valor-opcion');

                  var indiceOpcionColor = parseInt(boton.getAttribute('data-indice-opcion'), 10);
                  var valorColor = boton.getAttribute('data-valor-opcion');
                  var varianteDelColor = producto.variants.find(function (v) { return v.options[indiceOpcionColor] === valorColor; });
                  if (varianteDelColor && varianteDelColor.featured_image && varianteDelColor.featured_image.src) {
                    var indiceEnGaleria = imagenes.indexOf(varianteDelColor.featured_image.src);
                    if (indiceEnGaleria === -1) {
                      imagenes = [varianteDelColor.featured_image.src].concat(imagenes);
                      indiceEnGaleria = 0;
                    }
                    indiceImagen = indiceEnGaleria;
                    imagenElemento.setAttribute('src', varianteDelColor.featured_image.src);
                  } else {
                    indiceImagen = 0;
                    imagenElemento.setAttribute('src', imagenes[0]);
                  }

                  actualizarVariante();
                });
              });
            });

            actualizarVariante();

            botonAgregar.addEventListener('click', function () {
              var varianteId = botonAgregar.getAttribute('data-variante-id');
              if (!varianteId) return;
              mensajeElemento.textContent = 'Añadiendo...';
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: varianteId,
                  quantity: cantidadActual,
                  sections: ['cart-drawer'],
                  sections_url: window.location.pathname
                })
              })
                .then(function (respuesta) { return respuesta.json(); })
                .then(function (datosRespuesta) {
                  cerrarModal();

                  try {
                    var htmlSeccion = datosRespuesta.sections && datosRespuesta.sections['cart-drawer'];
                    var elementoActual = document.querySelector('cart-drawer');

                    if (htmlSeccion && elementoActual) {
                      var parser = new DOMParser();
                      var documentoNuevo = parser.parseFromString(htmlSeccion, 'text/html');
                      var elementoNuevo = documentoNuevo.querySelector('cart-drawer');

                      if (elementoNuevo) {
                        elementoActual.outerHTML = elementoNuevo.outerHTML;
                        var elementoActualizado = document.querySelector('cart-drawer');

                        requestAnimationFrame(function () {
                          elementoActualizado.classList.add('animate', 'active');
                        });
                        document.documentElement.classList.add('overflow-hidden');
                        vigilarCierreDeCarrito(elementoActualizado);
                      } else {
                        window.location.href = '/cart';
                      }
                    } else {
                      window.location.href = '/cart';
                    }
                  } catch (errorRenderizado) {
                    window.location.href = '/cart';
                  }
                })
                .catch(function () {
                  window.location.href = '/cart';
                });
            });

            botonComprar.addEventListener('click', function () {
              var varianteId = botonComprar.getAttribute('data-variante-id');
              if (!varianteId) return;
              mensajeElemento.textContent = 'Redirigiendo al pago...';
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: varianteId, quantity: cantidadActual })
              })
                .then(function () {
                  window.location.href = '/checkout';
                })
                .catch(function () {
                  mensajeElemento.textContent = 'Hubo un problema al procesar la compra.';
                });
            });
          })
          .catch(function () {
            cuerpo.innerHTML = '<p class="coleccion-destacada__mv-mensaje">No se pudo cargar el producto.</p>';
          });
      }

      function enlazarTarjeta(tarjeta) {
        var disparador = tarjeta.querySelector('[data-coleccion-destacada-compra-rapida]');
        if (disparador) {
          disparador.addEventListener('click', function (evento) {
            evento.preventDefault();
            evento.stopPropagation();
            abrirModal(disparador.getAttribute('data-producto-url'), disparador.getAttribute('data-insignia-nuevo'), disparador.getAttribute('data-colores-mapa'), disparador.getAttribute('data-mv-valoracion'), disparador.getAttribute('data-mv-total-valoraciones'));
          });
          disparador.addEventListener('keydown', function (evento) {
            if (evento.key === 'Enter' || evento.key === ' ') {
              evento.preventDefault();
              abrirModal(disparador.getAttribute('data-producto-url'), disparador.getAttribute('data-insignia-nuevo'), disparador.getAttribute('data-colores-mapa'), disparador.getAttribute('data-mv-valoracion'), disparador.getAttribute('data-mv-total-valoraciones'));
            }
          });
        }

        var swatches = tarjeta.querySelectorAll('[data-coleccion-destacada-swatch]');
        var enlaceImagen = tarjeta.querySelector('[data-coleccion-destacada-enlace-imagen]');
        var enlaceNombre = tarjeta.querySelector('[data-coleccion-destacada-enlace-nombre]');
        var imagenPrincipal = tarjeta.querySelector('[data-coleccion-destacada-imagen-principal]');
        var compraRapida = tarjeta.querySelector('[data-coleccion-destacada-compra-rapida]');
        var imagenOriginal = imagenPrincipal ? imagenPrincipal.getAttribute('src') : null;

        swatches.forEach(function (swatch) {
          swatch.addEventListener('click', function (evento) {
            evento.preventDefault();
            evento.stopPropagation();

            swatches.forEach(function (otro) {
              otro.classList.remove('coleccion-destacada__color--activo');
            });
            swatch.classList.add('coleccion-destacada__color--activo');

            var urlVariante = swatch.getAttribute('data-variante-url');
            var imagenVariante = swatch.getAttribute('data-variante-imagen');

            if (urlVariante) {
              if (enlaceImagen) enlaceImagen.setAttribute('href', urlVariante);
              if (enlaceNombre) enlaceNombre.setAttribute('href', urlVariante);
              if (compraRapida) compraRapida.setAttribute('data-producto-url', urlVariante);
            }

            if (imagenPrincipal) {
              imagenPrincipal.setAttribute('src', imagenVariante || imagenOriginal);
              imagenPrincipal.removeAttribute('srcset');
            }
          });
        });
      }

      seccion.querySelectorAll('[data-coleccion-destacada-tarjeta]').forEach(enlazarTarjeta);
      seccion.__enlazarTarjeta = enlazarTarjeta;

      var botonCargarMas = seccion.querySelector('[data-cf-cargar-mas]');
      var contenedorGrid = seccion.querySelector('[data-cf-grid]');

      function enlazarBotonCargarMas() {
        var boton = seccion.querySelector('[data-cf-cargar-mas]');
        if (!boton) return;
        boton.addEventListener('click', function () {
          var url = boton.getAttribute('data-cf-url');
          if (!url) return;
          boton.disabled = true;
          boton.textContent = 'Cargando...';

          fetch(url)
            .then(function (respuesta) { return respuesta.text(); })
            .then(function (html) {
              var parser = new DOMParser();
              var documentoNuevo = parser.parseFromString(html, 'text/html');
              var gridNuevo = documentoNuevo.querySelector('[data-cf-grid]');
              var pieNuevo = documentoNuevo.querySelector('[data-cf-pie-paginacion]');

              if (gridNuevo && contenedorGrid) {
                Array.prototype.slice.call(gridNuevo.children).forEach(function (tarjetaNueva) {
                  contenedorGrid.appendChild(tarjetaNueva);
                  enlazarTarjeta(tarjetaNueva);
                });
              }

              var pieActual = seccion.querySelector('[data-cf-pie-paginacion]');
              if (pieNuevo && pieActual) {
                pieActual.outerHTML = pieNuevo.outerHTML;
                enlazarBotonCargarMas();
              } else if (pieActual) {
                pieActual.remove();
              }
            })
            .catch(function () {
              boton.disabled = false;
              boton.textContent = '{{ section.settings.texto_cargar_mas }}';
            });
        });
      }

      enlazarBotonCargarMas();
      seccion.__enlazarBotonCargarMas = enlazarBotonCargarMas;

      // FIX: los conteos de "Disponibilidad" y "Color" renderizados por Liquid pueden
      // quedarse cortos (Shopify limita tanto {% paginate %} como collection.products
      // sin paginar a un máximo de ~50, y collection.filters depende de que la tienda
      // tenga configurados los filtros de Search & Discovery). Para garantizar que el
      // conteo SIEMPRE coincida con el total real de la colección, recorremos aquí, en
      // el navegador, todas las páginas de la colección (igual que "Cargar más", pero
      // en segundo plano) y recalculamos los conteos sobre el 100% de los productos.
      var mapaColoresRespaldo = {
        'rosa gold': '#B76E79', 'rose gold': '#B76E79', 'oro rosa': '#B76E79',
        'dorado': '#C9A265', 'gold': '#C9A265', 'oro': '#C9A265',
        'plateado': '#C0C0C0', 'silver': '#C0C0C0', 'plata': '#C0C0C0',
        'blanco': '#F5F1EA', 'white': '#F5F1EA', 'perla': '#F5F1EA', 'pearl': '#F5F1EA',
        'negro': '#000000', 'black': '#000000',
        'celeste': '#A7D8F0', 'sky': '#A7D8F0', 'azul claro': '#A7D8F0',
        'azul': '#3B5998', 'blue': '#3B5998', 'navy': '#3B5998',
        'rosado': '#E8A0BF', 'rosa': '#E8A0BF', 'pink': '#E8A0BF', 'fucsia': '#E8A0BF',
        'burgundy': '#6E1423', 'burdeos': '#6E1423', 'vino': '#6E1423',
        'coral': '#E67E22', 'rojo': '#8B2E2E', 'red': '#8B2E2E',
        'verde': '#2E8B57', 'green': '#2E8B57', 'oliva': '#2E8B57',
        'morado': '#7D3C98', 'purple': '#7D3C98', 'violeta': '#7D3C98', 'lila': '#7D3C98',
        'beige': '#E8DCC8', 'nude': '#E8DCC8', 'crema': '#E8DCC8',
        'cafe': '#6B4226', 'café': '#6B4226', 'marron': '#6B4226', 'marrón': '#6B4226', 'brown': '#6B4226', 'chocolate': '#6B4226',
        'gris': '#9A9A9A', 'gray': '#9A9A9A', 'grey': '#9A9A9A', 'plomo': '#9A9A9A',
        'amarillo': '#F1C40F', 'yellow': '#F1C40F', 'mostaza': '#F1C40F',
        'naranja': '#E67E22', 'orange': '#E67E22',
        'turquesa': '#2FBFA6', 'turquoise': '#2FBFA6', 'aqua': '#2FBFA6',
        'palo rosa': '#E7C7C2', 'aguamarina': '#7FCDCD', 'arcoiris': 'linear-gradient(135deg, #E8A0BF, #C9A265, #3B5998)', 'multicolor': 'linear-gradient(135deg, #E8A0BF, #C9A265, #3B5998)'
      };

      function obtenerColorHexRespaldo(nombre) {
        var nombreLower = nombre.toLowerCase();
        for (var clave in mapaColoresRespaldo) {
          if (nombreLower.indexOf(clave) !== -1) return mapaColoresRespaldo[clave];
        }
        return '#cccccc';
      }

      function recalcularConteosCompletos() {
        var totalProductos = parseInt(seccion.getAttribute('data-cf-total-productos') || '0', 10);
        var porPagina = parseInt(seccion.getAttribute('data-cf-por-pagina') || '0', 10);
        var urlBase = seccion.getAttribute('data-cf-collection-url');
        if (!totalProductos || !porPagina || !urlBase) return;

        var totalPaginas = Math.ceil(totalProductos / porPagina);
        var promesasPaginas = [];

        function extraerTarjetas(doc) {
          return Array.prototype.slice.call(doc.querySelectorAll('[data-cf-colores]')).map(function (elemento) {
            return {
              colores: (elemento.getAttribute('data-cf-colores') || '').split(',').map(function (c) { return c.trim(); }).filter(Boolean),
              disponible: elemento.getAttribute('data-cf-disponible') || '',
              precio: elemento.getAttribute('data-cf-precio') || '0',
              html: elemento.outerHTML
            };
          });
        }

        for (var pagina = 2; pagina <= totalPaginas; pagina++) {
          promesasPaginas.push(
            fetch(urlBase + '?page=' + pagina)
              .then(function (respuesta) { return respuesta.text(); })
              .then(function (html) {
                var parser = new DOMParser();
                return extraerTarjetas(parser.parseFromString(html, 'text/html'));
              })
              .catch(function () { return []; })
          );
        }

        Promise.all(promesasPaginas).then(function (paginasDatos) {
          var todasLasTarjetas = extraerTarjetas(seccion);
          paginasDatos.forEach(function (tarjetasPagina) {
            todasLasTarjetas = todasLasTarjetas.concat(tarjetasPagina);
          });

          // Se guarda el catálogo completo (con su HTML) en la sección para que el
          // filtrado pueda mostrar coincidencias de TODA la colección, no solo de las
          // tarjetas que ya estaban cargadas en pantalla.
          seccion.__todasLasTarjetas = todasLasTarjetas;
          seccion.__todasLasTarjetasListas = true;

          var totalDisponibles = 0;
          var totalAgotados = 0;
          var conteoColores = {};

          todasLasTarjetas.forEach(function (tarjeta) {
            if (tarjeta.disponible === 'disponible') {
              totalDisponibles += 1;
            } else if (tarjeta.disponible === 'agotado') {
              totalAgotados += 1;
            }
            tarjeta.colores.forEach(function (nombreColor) {
              conteoColores[nombreColor] = (conteoColores[nombreColor] || 0) + 1;
            });
          });

          var casillaDisponible = seccion.querySelector('[data-cf-filtro-disponible-cliente][value="disponible"]');
          var casillaAgotado = seccion.querySelector('[data-cf-filtro-disponible-cliente][value="agotado"]');
          var textoDisponible = seccion.querySelector('[data-cf-texto-disponible]');
          var textoAgotado = seccion.querySelector('[data-cf-texto-agotado]');
          if (textoDisponible) textoDisponible.textContent = 'En existencia (' + totalDisponibles + ')';
          if (textoAgotado) textoAgotado.textContent = 'Agotado (' + totalAgotados + ')';
          if (casillaDisponible) casillaDisponible.disabled = totalDisponibles === 0;
          if (casillaAgotado) casillaAgotado.disabled = totalAgotados === 0;

          var listaColores = seccion.querySelector('[data-cf-lista-colores]');
          if (!listaColores) return;

          var hexConocidos = {};
          listaColores.querySelectorAll('[data-cf-item-color]').forEach(function (item) {
            hexConocidos[item.getAttribute('data-cf-nombre')] = item.getAttribute('data-cf-hex');
          });

          var nombresOrdenados = Object.keys(conteoColores).sort();
          listaColores.innerHTML = '';
          nombresOrdenados.forEach(function (nombreColor) {
            var hex = hexConocidos[nombreColor] || obtenerColorHexRespaldo(nombreColor);
            var li = document.createElement('li');
            li.setAttribute('data-cf-item-color', '');
            li.setAttribute('data-cf-nombre', nombreColor);
            li.setAttribute('data-cf-hex', hex);
            li.innerHTML =
              '<label class="coleccion-destacada__filtro-checkbox-fila coleccion-destacada__filtro-checkbox-fila--color">' +
                '<input type="checkbox" data-cf-filtro-color-cliente value="' + nombreColor + '">' +
                '<span class="coleccion-destacada__filtro-color-circulo" style="background: ' + hex + ';"></span>' +
                '<span data-cf-texto-color>' + nombreColor.charAt(0).toUpperCase() + nombreColor.slice(1) + ' (' + conteoColores[nombreColor] + ')</span>' +
              '</label>';
            listaColores.appendChild(li);
          });

          var formularioActual = seccion.querySelector('[data-cf-form]');
          if (formularioActual && typeof formularioActual.dispatchEvent === 'function') {
            formularioActual.dispatchEvent(new CustomEvent('cf:colores-actualizados'));
            formularioActual.dispatchEvent(new CustomEvent('cf:catalogo-listo'));
          }
        });
      }

      // Panel de filtros en móvil: oculto por defecto, se abre/cierra con el botón "Filtrar".
      var botonToggleFiltros = seccion.querySelector('[data-cf-toggle-filtros]');
      var sidebarFiltros = seccion.querySelector('[data-cf-sidebar]');
      var botonCerrarFiltros = seccion.querySelector('[data-cf-cerrar-filtros]');

      function abrirCerrarFiltros(forzarAbierto) {
        if (!sidebarFiltros || !botonToggleFiltros) return;
        var abrir = typeof forzarAbierto === 'boolean' ? forzarAbierto : !sidebarFiltros.classList.contains('coleccion-destacada__sidebar--abierto');
        sidebarFiltros.classList.toggle('coleccion-destacada__sidebar--abierto', abrir);
        botonToggleFiltros.setAttribute('aria-expanded', abrir ? 'true' : 'false');
      }

      if (botonToggleFiltros) {
        botonToggleFiltros.addEventListener('click', function () {
          abrirCerrarFiltros();
        });
      }

      if (botonCerrarFiltros) {
        botonCerrarFiltros.addEventListener('click', function () {
          abrirCerrarFiltros(false);
        });
      }

      seccion.__cerrarPanelFiltrosMovil = function () {
        abrirCerrarFiltros(false);
      };

      recalcularConteosCompletos();
    });

    document.querySelectorAll('[data-cf-form]').forEach(function (formulario) {
      var seccionFormulario = formulario.closest('[data-coleccion-destacada]');
      var grid = seccionFormulario ? seccionFormulario.querySelector('[data-cf-grid]') : null;
      var piePaginacion = seccionFormulario ? seccionFormulario.querySelector('[data-cf-pie-paginacion]') : null;
      var gridOriginalHtml = grid ? grid.innerHTML : '';
      var piePaginacionOriginalHtml = piePaginacion ? piePaginacion.innerHTML : '';
      var piePaginacionPadre = piePaginacion ? piePaginacion.parentElement : null;
      var filtrandoActualmente = false;

      var casillasColor = formulario.querySelectorAll('[data-cf-filtro-color-cliente]');
      var casillasDisponible = formulario.querySelectorAll('[data-cf-filtro-disponible-cliente]');
      var sliderMax = formulario.querySelector('[data-cf-precio-slider-max]');
      var salidaMax = formulario.querySelector('[data-cf-precio-max]');
      var inputMax = formulario.querySelector('[data-cf-precio-max-input]');
      var rangoMinimo = sliderMax ? parseFloat(sliderMax.min) : 0;
      var rangoMaximo = sliderMax ? parseFloat(sliderMax.max) : 0;

      function limpiarMensajeVacio() {
        if (!grid || !grid.parentElement) return;
        var mensajePrevio = grid.parentElement.querySelector('[data-cf-mensaje-vacio]');
        if (mensajePrevio) mensajePrevio.remove();
      }

      function restaurarGridOriginal() {
        if (!grid) return;
        limpiarMensajeVacio();
        grid.innerHTML = gridOriginalHtml;
        grid.querySelectorAll('[data-coleccion-destacada-tarjeta]').forEach(function (tarjetaOriginal) {
          if (seccionFormulario && typeof seccionFormulario.__enlazarTarjeta === 'function') {
            seccionFormulario.__enlazarTarjeta(tarjetaOriginal);
          }
        });
        if (piePaginacion && !piePaginacion.isConnected && piePaginacionPadre) {
          piePaginacionPadre.appendChild(piePaginacion);
        }
        if (piePaginacion) {
          piePaginacion.innerHTML = piePaginacionOriginalHtml;
          piePaginacion.style.display = '';
          if (seccionFormulario && typeof seccionFormulario.__enlazarBotonCargarMas === 'function') {
            seccionFormulario.__enlazarBotonCargarMas();
          }
        }
      }

      function aplicarFiltrosCombinados() {
        var coloresSeleccionados = [];
        casillasColor.forEach(function (casilla) {
          if (casilla.checked) coloresSeleccionados.push(casilla.value);
        });

        var disponibilidadSeleccionada = [];
        casillasDisponible.forEach(function (casilla) {
          if (casilla.checked) disponibilidadSeleccionada.push(casilla.value);
        });

        var precioMaximoPermitido = sliderMax ? parseFloat(sliderMax.value) * 100 : null;
        var precioActivo = precioMaximoPermitido !== null && rangoMaximo > rangoMinimo && parseFloat(sliderMax.value) < rangoMaximo;

        var hayFiltroActivo = coloresSeleccionados.length > 0 || disponibilidadSeleccionada.length > 0 || precioActivo;

        if (!hayFiltroActivo) {
          if (filtrandoActualmente) {
            restaurarGridOriginal();
            filtrandoActualmente = false;
          }
          return;
        }

        if (!grid) return;
        filtrandoActualmente = true;
        limpiarMensajeVacio();

        // Mientras el catálogo completo (todas las páginas) todavía se está descargando en
        // segundo plano, se filtra sobre lo que ya esté disponible; en cuanto termine de
        // cargar, el evento "cf:catalogo-listo" vuelve a llamar a esta función con los datos
        // completos.
        var fuenteDatos = (seccionFormulario && seccionFormulario.__todasLasTarjetas) ||
          Array.prototype.slice.call((seccionFormulario || document).querySelectorAll('[data-cf-colores]')).map(function (elemento) {
            return {
              colores: (elemento.getAttribute('data-cf-colores') || '').split(',').map(function (c) { return c.trim(); }).filter(Boolean),
              disponible: elemento.getAttribute('data-cf-disponible') || '',
              precio: elemento.getAttribute('data-cf-precio') || '0',
              html: elemento.outerHTML
            };
          });

        var coincidencias = fuenteDatos.filter(function (item) {
          var pasaColor = true;
          if (coloresSeleccionados.length > 0) {
            pasaColor = coloresSeleccionados.some(function (color) {
              return item.colores.indexOf(color) !== -1;
            });
          }

          var pasaDisponibilidad = true;
          if (disponibilidadSeleccionada.length > 0) {
            pasaDisponibilidad = disponibilidadSeleccionada.indexOf(item.disponible) !== -1;
          }

          var pasaPrecio = true;
          if (precioActivo) {
            pasaPrecio = parseFloat(item.precio || '0') <= precioMaximoPermitido;
          }

          return pasaColor && pasaDisponibilidad && pasaPrecio;
        });

        grid.innerHTML = '';
        coincidencias.forEach(function (item) {
          var envoltorio = document.createElement('div');
          envoltorio.innerHTML = item.html;
          var tarjetaNueva = envoltorio.firstElementChild;
          if (!tarjetaNueva) return;
          grid.appendChild(tarjetaNueva);
          if (seccionFormulario && typeof seccionFormulario.__enlazarTarjeta === 'function') {
            seccionFormulario.__enlazarTarjeta(tarjetaNueva);
          }
        });

        // En vez de ocultar el pie de página, se actualiza para reflejar el total real
        // filtrado. Como al filtrar se muestran TODAS las coincidencias de una sola vez
        // (no hay más páginas que cargar dentro de un filtro), no tiene sentido mostrar
        // el botón "Cargar más": se reemplaza por el conteo final del filtro aplicado.
        if (piePaginacion) {
          var catalogoCompleto = !!(seccionFormulario && seccionFormulario.__todasLasTarjetasListas);
          var textoConteo = catalogoCompleto
            ? 'Se encontraron ' + coincidencias.length + ' productos con estos filtros'
            : 'Cargando catálogo completo… ' + coincidencias.length + ' productos encontrados hasta ahora';
          piePaginacion.innerHTML =
            '<p class="coleccion-destacada__progreso-texto">' + textoConteo + '</p>' +
            '<div class="coleccion-destacada__progreso-barra"><div class="coleccion-destacada__progreso-relleno" style="width:' + (catalogoCompleto ? '100' : '60') + '%;"></div></div>';
          piePaginacion.style.display = '';
        }

        if (coincidencias.length === 0) {
          var mensajeVacio = document.createElement('p');
          mensajeVacio.className = 'coleccion-destacada__progreso-texto';
          mensajeVacio.setAttribute('data-cf-mensaje-vacio', '');
          mensajeVacio.textContent = 'No hay productos que coincidan con los filtros seleccionados.';
          grid.parentElement.insertBefore(mensajeVacio, grid.nextSibling);
        }
      }

      if (sliderMax) {
        function actualizarSliderPrecio() {
          var valorMax = parseFloat(sliderMax.value);

          if (salidaMax) salidaMax.textContent = valorMax.toLocaleString('es-CO');
          if (inputMax) inputMax.value = Math.round(valorMax * 100);

          if (rangoMaximo > rangoMinimo) {
            var porcentajeMax = ((valorMax - rangoMinimo) / (rangoMaximo - rangoMinimo)) * 100;
            sliderMax.style.setProperty('--cf-relleno', porcentajeMax + '%');
          }

          aplicarFiltrosCombinados();
        }

        actualizarSliderPrecio();
        sliderMax.addEventListener('input', actualizarSliderPrecio);
      }

      casillasColor.forEach(function (casilla) {
        casilla.addEventListener('change', aplicarFiltrosCombinados);
      });

      casillasDisponible.forEach(function (casilla) {
        casilla.addEventListener('change', aplicarFiltrosCombinados);
      });

      formulario.addEventListener('submit', function (evento) {
        evento.preventDefault();
      });

      // La lista de colores se reconstruye por completo cuando recalcularConteosCompletos()
      // termina de recorrer todas las páginas de la colección, así que hay que volver a
      // capturar los checkboxes (los anteriores ya no existen en el DOM) y re-enlazar el
      // evento "change" en los nuevos.
      formulario.addEventListener('cf:colores-actualizados', function () {
        casillasColor = formulario.querySelectorAll('[data-cf-filtro-color-cliente]');
        casillasColor.forEach(function (casilla) {
          casilla.addEventListener('change', aplicarFiltrosCombinados);
        });
        aplicarFiltrosCombinados();
      });

      // Cuando termina de descargarse el catálogo completo en segundo plano, se vuelve a
      // aplicar el filtro (si hay alguno activo) usando ya los datos de las 100% de las
      // páginas, no solo de la primera.
      formulario.addEventListener('cf:catalogo-listo', function () {
        aplicarFiltrosCombinados();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
